import {ReactNode} from 'react'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {StyledCardHeader, StyledExportCard} from './style'

// Presentational shell shared by the DSP Flux and Merge cards: an icon chip + title header over a
// free-form footer (the select + action row).
export const ExportCardShell = ({
    icon,
    title,
    disabled,
    children
}: {
    icon: ReactNode
    title: string
    disabled?: boolean
    children: ReactNode
}) => (
    <StyledExportCard $disabled={disabled}>
        <StyledCardHeader>
            <Flexbox align="center" gap={2}>
                {icon}
                <Text size="textMd" palette="neutral" shade="900" weight="600">
                    {title}
                </Text>
            </Flexbox>
        </StyledCardHeader>
        {children}
    </StyledExportCard>
)
